import React from "react";
import "./whyhead.css";

export default function Whyhead() {
  return (
    <section className="why2-choose2-section2">
      <div className="header3-text3">
        <h1>
          Why Choose Glamur Paints
          <br />
          Pakistan’s Premier Paint Brand
        </h1>
        <p>
          At Glamur Paint, we don’t just sell paint, we bring walls to life. Our
          paints are crafted with cutting-edge technology, vibrant pigments,
          and eco-friendly materials to ensure long-lasting beauty, protection,
          and peace of mind. Whether you’re transforming a single room or your
          entire home, Glamur Paint guarantees perfection in every stroke.
        </p>
      </div>

    </section>
  );
}
